/* eslint-disable camelcase */
import Http from './http'

export const deleteOffer = (offerId, token) => {
  return Http.delete(`/api/offers/${offerId}`, { headers: { Authorization: `Bearer ${token}` } })
}

export const deleteGroup = (offerId, token) => {
  return Http.delete(`/api/offer-groups/${offerId}`, { headers: { Authorization: `Bearer ${token}` } })
}

export const getOfferGroup = (offerId, token) => {
  return Http.get(`/api/offer-groups/${offerId}`, { headers: { Authorization: `Bearer ${token}` } })
}

export const getOffer = (offerId, token) => {
  return Http.get(`/api/offers/${offerId}`, { headers: { Authorization: `Bearer ${token}` } })
}

export const editOffer = (offerId, token) => {
  return Http.get(`/api/offers/${offerId}/edit`, { headers: { Authorization: `Bearer ${token}` } })
}

export const updateGroup = (offerGroupId, offerGroup, token) => {
  const { boleto_url, approved_url, html_code, name, brand, site, email, soft_descriptor, support_phone, risk_category_id } = offerGroup
  return Http.put(`/api/offer-groups/${offerGroupId}`,
    {
      name: name,
      brand: brand,
      soft_descriptor: soft_descriptor,
      site: site,
      email: email,
      support_phone: support_phone,
      boleto_url: boleto_url,
      approved_url: approved_url,
      html_code: html_code,
      risk_category_id: risk_category_id,
    }, { headers: { Authorization: `Bearer ${token}` } })
}

export const createGroup = (offerGroup, token) => {
  const { boleto_url, approved_url, html_code, name, brand, site, email, soft_descriptor, support_phone, risk_category_id } = offerGroup
  return Http.post('/api/offer-groups',
    {
      name: name,
      brand: brand,
      soft_descriptor: soft_descriptor,
      site: site,
      email: email,
      support_phone: support_phone,
      boleto_url: boleto_url,
      approved_url: approved_url,
      html_code: html_code,
      risk_category_id: risk_category_id,
    }, { headers: { Authorization: `Bearer ${token}` } })
}

/**
 * Duplicate an offer
 * @param {string} offerId
 * @param {string} token
 */
export const duplicateGroup = (groupId, token) => {
  return Http.post(`/api/offer-groups/${groupId}/clone`, {}, { headers: { Authorization: `Bearer ${token}` } })
}

/**
 * Duplicate an offer
 * @param {string} offerId
 * @param {string} token
 */
export const duplicateOffer = (offerId, token) => {
  return Http.post(`/api/offers/${offerId}/clone`, {}, { headers: { Authorization: `Bearer ${token}` } })
}

export const updateOffer = (offerId, offer, token) => {
  const { name, brand, shipping_cost, products, approved_url,
    boleto_url, header_image, header_description, description, upsell,
    days_to_deliver, site, soft_descriptor, boleto_enabled, credit_enabled,
    boleto_expiration_days, installments_max, installments_interest_rate,
    installments_default, email, support_phone, group_id, track_code,hide_cpf, 
    active, product_type, checkout_type } = offer
  return Http.put(`/api/offers/${offerId}`,
    {
      name: name,
      brand: brand,
      shipping_cost: shipping_cost,
      products: products,
      approved_url: approved_url,
      boleto_url: boleto_url,
      header_image: header_image,
      header_description: header_description,
      description: description,
      days_to_deliver: days_to_deliver,
      site: site,
      soft_descriptor: soft_descriptor,
      boleto_enabled: boleto_enabled,
      credit_enabled: credit_enabled,
      boleto_expiration_days: boleto_expiration_days,
      installments_max: installments_max,
      installments_interest_rate: installments_interest_rate,
      installments_default: installments_default,
      email: email,
      support_phone: support_phone,
      group_id: group_id,
      track_code: track_code,
      upsell: upsell,
      hide_cpf: hide_cpf,
      product_type: product_type,
      checkout_type: checkout_type,
      active: active,
    },
    { headers: { Authorization: `Bearer ${token}` } })
}

/**
 * Create an offer
 *
 * @param {Object} offer
 * @param {string} token
 *
 * @returns {Promise}
 */
export const createOfferPlan = (offer, token) => {
  const { name, brand, shipping_cost, products, approved_url,
    boleto_url, header_image, header_description, description, upsell,
    days_to_deliver, site, soft_descriptor, boleto_enabled, credit_enabled,
    boleto_expiration_days, installments_max, installments_interest_rate,
    installments_default, email, support_phone, group_id, track_code, hide_cpf, 
    active, product_type, checkout_type, plan } = offer

  return Http.post('/api/offers/plan',
    {
      name: name,
      brand: brand,
      shipping_cost: shipping_cost,
      products: products,
      approved_url: approved_url,
      boleto_url: boleto_url,
      header_image: header_image,
      header_description: header_description,
      description: description,
      days_to_deliver: days_to_deliver,
      site: site,
      soft_descriptor: soft_descriptor,
      boleto_enabled: boleto_enabled,
      credit_enabled: credit_enabled,
      boleto_expiration_days: boleto_expiration_days,
      installments_max: installments_max,
      installments_interest_rate: installments_interest_rate,
      installments_default: installments_default,
      email: email,
      support_phone: support_phone,
      group_id: group_id,
      track_code: track_code,
      upsell: upsell,
      hide_cpf: hide_cpf,
      product_type: product_type,
      checkout_type: checkout_type,
      active: active,
      plan: plan,
    },
    { headers: { Authorization: `Bearer ${token}` } })
}

/**
 * Create an offer
 *
 * @param {Object} offer
 * @param {string} token
 *
 * @returns {Promise}
 */
export const createOffer = (offer, token) => {
  const { name, brand, shipping_cost, products, approved_url,
    boleto_url, header_image, header_description, description, upsell,
    days_to_deliver, site, soft_descriptor, boleto_enabled, credit_enabled,
    boleto_expiration_days, installments_max, installments_interest_rate,
    installments_default, email, support_phone, group_id, track_code, hide_cpf, 
    active, product_type, checkout_type } = offer

  return Http.post('/api/offers',
    {
      name: name,
      brand: brand,
      shipping_cost: shipping_cost,
      products: products,
      approved_url: approved_url,
      boleto_url: boleto_url,
      header_image: header_image,
      header_description: header_description,
      description: description,
      days_to_deliver: days_to_deliver,
      site: site,
      soft_descriptor: soft_descriptor,
      boleto_enabled: boleto_enabled,
      credit_enabled: credit_enabled,
      boleto_expiration_days: boleto_expiration_days,
      installments_max: installments_max,
      installments_interest_rate: installments_interest_rate,
      installments_default: installments_default,
      email: email,
      support_phone: support_phone,
      group_id: group_id,
      track_code: track_code,
      upsell: upsell,
      hide_cpf: hide_cpf,
      product_type: product_type,
      checkout_type: checkout_type,
      active: active,
    },
    { headers: { Authorization: `Bearer ${token}` } })
}

/**
 * Get all offers group
 *
 * @param {string} token
 *
 * @returns {Promise}
 */
export const getAllGroups = (token) => {
  return Http.get('/api/offer-groups', { headers: { Authorization: `Bearer ${token}` } })
}

/**
 * Get all offers
 *
 * @param {string} token
 *
 * @returns {Promise}
 */
export const getAllOffers = (token) => {
  return Http.get('/api/offers', { headers: { Authorization: `Bearer ${token}` } })
}
